export default "__VITE_ASSET__GxxJbjRc__"